import React, { useState, useContext, useEffect } from 'react';
import {
	Button,
	Paper,
	Typography,
	TableContainer,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Table,
	IconButton,
	Stack,
	Menu,
	MenuItem,
	ListItemIcon,
	ListItemText
} from '@mui/material';
import { isEmpty } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faCalendarDays,
	faCirclePlus,
	faPrint,
	faTrashAlt,
	faExchangeAlt
} from '@fortawesome/free-solid-svg-icons';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { deleteToken, deleteUserData, getRol, getToken } from '../../../api/Account';
import { DataContext } from '../../../context/DataContext';

import { isAccess, simpleMessage } from '../../../helpers/Helpers';

import NoData from '../../../components/NoData';
import SmallModal from '../../../components/modals/SmallModal';
import MediumModal from '../../../components/modals/MediumModal';

import AddAbono from './quoteComponents/AddAbono';
import {
	deleteQuoteAsync,
	deleteQuoteNominalAsync,
	getBillDetailsAsync,
	getCreditQuotesAsync,
	changeFormaPagoAsync
} from '../../../api/Credits';
import moment from 'moment/moment';
import DetalleAbono from './quoteComponents/DetalleAbono';
import ChangeFechaAbono from './quoteComponents/ChangeFechaAbono';

const CreditAbono = ({ id, isNominal, dataCredit }) => {
	const [quotesList, setQuotesList] = useState([]);
	const [selectedQuote, setSelectedQuote] = useState(0);

	const [modal, setModal] = useState(false);
	const {
		setIsLoading,
		setIsLogged,
		setIsUnautorized,
		access,
		showPrintBillModal,
		setShowPrintBillModal,
		setDataAbono
	} = useContext(DataContext);
	const token = getToken();
	const [localReload, setLocalReload] = useState(false);

	const { isCanceled, isDolar } = dataCredit;

	const [anchorEl, setAnchorEl] = useState(null);
	const [selectedRow, setSelectedRow] = useState(null);

	const openMenu = (event, row) => {
		setAnchorEl(event.currentTarget);
		setSelectedRow(row);
	};

	const closeMenu = () => {
		setAnchorEl(null);
		setSelectedRow(null);
	};

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getCreditQuotesAsync(token, id);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setQuotesList(result.data.result);
			setIsLoading(false);
		})();
	}, [localReload]);

	const [addQuoteModal, setAddQuoteModal] = useState(false);

	const AnulateQuote = async (item) => {
		Swal.fire({
			title: '¿Estas Seguro?',
			text: 'No podras revertir esto...!',
			icon: 'warning',
			showCancelButton: true,

			confirmButtonColor: '#2979ff',
			cancelButtonColor: '#f50057',

			confirmButtonText: 'Eliminar!',
			cancelButtonText: 'Cancelar',
			customClass: {
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				(async () => {
					setIsLoading(true);
					const result = isNominal
						? await deleteQuoteNominalAsync(token, item)
						: await deleteQuoteAsync(token, item);
					if (!result.statusResponse) {
						setIsLoading(false);
						simpleMessage(result.error, 'error');
						return;
					}
					if (result.error === 'Unauthorized') {
						setIsLoading(false);
						deleteUserData();
						deleteToken();
						setIsLogged(false);
						return;
					}
					setIsLoading(false);
					setLocalReload(!localReload);
					Swal.fire('Eliminada!', 'Quota Eliminada.', 'success');
				})();
			}
		});
	};

	const changeFechaAbono = async (item) => {
		setSelectedQuote(item);
		setModal(true);
	};

	const reprintBill = async (quoteId) => {
		setIsLoading(true);
		const result = await getBillDetailsAsync(token, quoteId);
		if (!result.statusResponse) {
			setIsLoading(false);
			simpleMessage(result.error, 'error');
			return;
		}
		if (result.error === 'Unauthorized') {
			setIsLoading(false);
			deleteUserData();
			deleteToken();
			setIsLogged(false);
			return;
		}
		setIsLoading(false);
		setDataAbono(result.data.result);
		setShowPrintBillModal(true);
	};

	const changeFormaPago = async (quoteId) => {
		Swal.fire({
			title: '¿Estas Seguro?',
			text: 'Cambiaras la forma de pago de la cuota...!',
			icon: 'warning',
			showCancelButton: true,

			confirmButtonColor: '#2979ff',
			cancelButtonColor: '#f50057',

			confirmButtonText: 'Eliminar!',
			cancelButtonText: 'Cancelar',
			customClass: {
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				(async () => {
					setIsLoading(true);
					const result = await changeFormaPagoAsync(token, quoteId);
					if (!result.statusResponse) {
						setIsLoading(false);
						simpleMessage(result.error, 'error');
						return;
					}

					setIsLoading(false);
					setLocalReload(!localReload);
					Swal.fire('Actualizada!', 'Forma de pago actualizada.', 'success');
				})();
			}
		});
	};

	return (
		<div>
			<Paper
				style={{
					padding: 10
				}}
			>
				<Stack
					direction={{ xs: 'column', sm: 'row' }}
					alignItems="center"
					justifyContent={'space-between'}
				>
					<Typography
						textAlign={'left'}
						color={'#00a152'}
						variant="h6"
						fontWeight={'bold'}
					>
						Abonos
					</Typography>
					{isAccess(access, 'CREDITS CREATE') && !isCanceled ? (
						<Button
							onClick={() => {
								setAddQuoteModal(true);
							}}
							style={{
								color: '#00a152',
								borderColor: '#00a152'
							}}
							variant="outlined"
						>
							<FontAwesomeIcon
								style={{ marginRight: 10, fontSize: 20 }}
								icon={faCirclePlus}
							/>
							Agregar
						</Button>
					) : null}
				</Stack>
				<hr />
				{isEmpty(quotesList) ? (
					<NoData />
				) : (
					<TableContainer>
						<Table aria-label="simple table" size="small">
							<TableHead>
								<TableRow>
									<TableCell align="center" className="text-primary fw-bold">
										#
									</TableCell>
									<TableCell align="center" className="text-primary fw-bold">
										Fecha Pago
									</TableCell>
									<TableCell align="center" className="text-primary fw-bold">
										Capital
									</TableCell>
									<TableCell align="center" className="text-primary fw-bold">
										Interes C.
									</TableCell>
									<TableCell align="center" className="text-primary fw-bold">
										Interes M.
									</TableCell>
									<TableCell align="center" className="text-primary fw-bold">
										Abono T.
									</TableCell>
									<TableCell align="left" className="text-primary fw-bold">
										Concepto
									</TableCell>
									<TableCell align="left" className="text-primary fw-bold">
										Forma de Pago
									</TableCell>

									<TableCell align="center" className="text-primary fw-bold">
										Acciones
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{quotesList.map((row) => {
									return (
										<TableRow key={row.id}>
											<TableCell align="center" component="th" scope="row">
												{row.id}
											</TableCell>
											<TableCell align="center" component="th" scope="row">
												{moment(row.fechaPago).format('L')}
											</TableCell>
											<TableCell align="center">
												{new Intl.NumberFormat(
													isDolar ? 'en-US' : 'es-NI',
													{
														style: 'currency',
														currency: isDolar ? 'USD' : 'NIO'
													}
												).format(row.ac)}
											</TableCell>
											<TableCell align="center">
												{new Intl.NumberFormat(
													isDolar ? 'en-US' : 'es-NI',
													{
														style: 'currency',
														currency: isDolar ? 'USD' : 'NIO'
													}
												).format(row.ic)}
											</TableCell>
											<TableCell align="center">
												{new Intl.NumberFormat(
													isDolar ? 'en-US' : 'es-NI',
													{
														style: 'currency',
														currency: isDolar ? 'USD' : 'NIO'
													}
												).format(row.aim)}
											</TableCell>
											<TableCell align="center">
												{new Intl.NumberFormat(
													isDolar ? 'en-US' : 'es-NI',
													{
														style: 'currency',
														currency: isDolar ? 'USD' : 'NIO'
													}
												).format(row.totalRecibido)}
											</TableCell>
											<TableCell align="left">{row.concepto}</TableCell>
											<TableCell align="left">{row.formaPago}</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
											>
												<IconButton
													style={{
														color: '#2979ff',
														width: 40,
														height: 40
													}}
													onClick={(e) => openMenu(e, row)}
												>
													<FontAwesomeIcon icon={faEllipsisVertical} />
												</IconButton>

												{/* {isAccess(access, 'EDIT FECHA CUOTA') ? (
													<IconButton
														style={{
															color: '#ffc400',
															width: 40,
															height: 40
														}}
														onClick={() => changeFechaAbono(row)}
													>
														<FontAwesomeIcon icon={faCalendarDays} />
													</IconButton>
												) : (
													<></>
												)}
												<IconButton
													style={{
														color: '#2979ff',
														width: 40,
														height: 40
													}}
													onClick={() => reprintBill(row.id)}
												>
													<FontAwesomeIcon icon={faPrint} />
												</IconButton>

												{isAccess(access, 'CREDITS DELETE') ? (
													<IconButton
														style={{
															color: '#f50057',
															width: 40,
															height: 40
														}}
														onClick={() => AnulateQuote(row.id)}
													>
														<FontAwesomeIcon icon={faTrashAlt} />
													</IconButton>
												) : (
													<></>
												)} */}
											</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
				)}
			</Paper>

			<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
				{isAccess(access, 'CHANGE FORMA PAGO') && (
					<MenuItem
						onClick={() => {
							changeFormaPago(selectedRow.id);
							closeMenu();
						}}
					>
						<ListItemIcon sx={{ color: '#2979ff' }}>
							<FontAwesomeIcon icon={faExchangeAlt} />
						</ListItemIcon>
						<ListItemText>Cambiar forma de pago</ListItemText>
					</MenuItem>
				)}

				{isAccess(access, 'EDIT FECHA CUOTA') && (
					<MenuItem
						onClick={() => {
							changeFechaAbono(selectedRow);
							closeMenu();
						}}
					>
						<ListItemIcon sx={{ color: '#ffc400' }}>
							<FontAwesomeIcon icon={faCalendarDays} />
						</ListItemIcon>
						<ListItemText>Cambiar fecha</ListItemText>
					</MenuItem>
				)}

				<MenuItem
					onClick={() => {
						reprintBill(selectedRow.id);
						closeMenu();
					}}
				>
					<ListItemIcon sx={{ color: '#2979ff' }}>
						<FontAwesomeIcon icon={faPrint} />
					</ListItemIcon>
					<ListItemText>Reimprimir recibo</ListItemText>
				</MenuItem>

				{isAccess(access, 'CREDITS DELETE') && (
					<MenuItem
						onClick={() => {
							AnulateQuote(selectedRow.id);
							closeMenu();
						}}
					>
						<ListItemIcon sx={{ color: '#f50057' }}>
							<FontAwesomeIcon icon={faTrashAlt} />
						</ListItemIcon>
						<ListItemText>Eliminar</ListItemText>
					</MenuItem>
				)}
			</Menu>

			<SmallModal
				titulo={'Agregar Abono'}
				isVisible={addQuoteModal}
				setVisible={setAddQuoteModal}
			>
				<AddAbono
					setShowModal={setAddQuoteModal}
					id={id}
					localReload={localReload}
					setLocalReload={setLocalReload}
					isNominal={isNominal}
				/>
			</SmallModal>

			<SmallModal titulo={'Cambiar Fecha Abono'} isVisible={modal} setVisible={setModal}>
				<ChangeFechaAbono
					setModal={setModal}
					selectedQuote={selectedQuote}
					localReload={localReload}
					setLocalReload={setLocalReload}
				/>
			</SmallModal>

			<MediumModal
				titulo={'Detalle Abono'}
				isVisible={showPrintBillModal}
				setVisible={setShowPrintBillModal}
			>
				<DetalleAbono setShowModal={setShowPrintBillModal} isDolar={isDolar} />
			</MediumModal>
		</div>
	);
};

export default CreditAbono;
